import API from "../utils/axios";
import { getTokenFromLocalStorage } from "../utils/local-storage";

var headers;
var url;

export const detailquestion_seperate = async (data) => {
  const authExist = getTokenFromLocalStorage();

  if (authExist == "") {
    url = "/questions/public/";
  } else {
    url = "/questions/";
    headers = {
      "Content-Type": "application/json",
      authorization: `Token ${authExist} `,
    };
  }

  const response = await API.get(url + data, { headers })
    .then((res) => res)
    .catch((err) => err);

  if (!!response.data) {
    return response.data;
  } else {
    return {};
  }
};
